import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll();


require("fslightbox");

if($('[data-fslightbox]').length > 0){
    fsLightbox.props.type = "image";
}

// require('../../node_modules/simplelightbox/dist/simple-lightbox.min.js');

import { gsap }                 from "gsap";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import * as Menu                from "./components/Menu";
// import * as Search              from "./components/Search";


import AjaxLoadPage             from "./components/AjaxLoadPage";
import ScrollEvents             from "./components/ScrollEvents";
import SwiperGalleries          from './components/SwiperGallery';
import Buy                      from './components/Buy';
// import SimpleLightbox           from "./components/SimpleLightBox";
// import * as Intros              from "./components/IntroPage";
import * as mask                from "./components/jqMask";
import * as jqValidate          from "./components/JqValidate";
// import * as Gallery             from "./components/Gallery";
import * as Svg                 from "./components/Svg";
import * as ModalVideo          from "./components/ModalVideo";
import * as FormAjax 			from "./components/FormAjax";
import * as CustomDropdown		from "./components/CustomDropdown";
import * as CustomSwitch        from "./components/Switch";

// loader site
AjaxLoadPage.init(0);
document.onreadystatechange = function () {
    //AjaxLoadPage.init(1);
    jqValidate.formAjax();
    // window.scrollTo({top: 0});
    if (document.readyState == "complete") {
        app();
    }
}

const app = () => {
    Menu.init();
    update();
}

window.update = () =>{
    // Search.init();
    // Intros.init();
    mask.inputsMask();
    FormAjax.init();
    ScrollEvents.init();
    CustomDropdown.init();
    CustomSwitch.init();
    SwiperGalleries.init();
    jqValidate.formAjax();
    jqValidate.shipping();
    ModalVideo.init();
    Buy.init();
    // SimpleLightbox.init();
    setTimeout(()=>{
        Svg.init();
    },500)
}
